import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Moment from 'moment';

import { makeStyles, useTheme } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import IconButton from '@mui/material/IconButton';

import DeleteIcon from '@mui/icons-material/Delete';

import Helpers from '../../libraries/helpers';
import Auth from '../../data/auth-service';
import CopyText from '../copytext';

const useStyles = makeStyles(theme => ({
    statusColorBox: {
        borderRadius: '4px',
    },
    good: {
        background: theme.palette.success.main,
    },
    kindaNotgood: {
        background: theme.palette.warning.main,
    },
    notGood: {
        background: theme.palette.error.main,
    },
    dataBox: {
        background: theme.palette.background.paper
    },
    textCenter: {
        textAlign: 'center',
    },
    nodeData: {
        color: theme.palette.secondary.light,
    },
    hidden: {
        display: 'none',
    },
    contentPad: {
        padding: '2px',
    },
}));

const Indices = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const clusterPerms = Auth.permissions.get('Cluster');

    // const cg = [
    //     { val: 0, title: 'Disk', small: true, size: 80 },
    //     { val: 8, title: 'Heap', small: true, size: 80 },
    // ];

    return (
        <Grid item lg={4}>
            <Paper elevation={3}>
                <Box className={clsx({
                    [classes.statusColorBox]: true,
                    [classes.good]: props.indexData.status === 'green',
                    [classes.kindaNotgood]: props.indexData.status === 'yellow',
                    [classes.notGood]: props.indexData.status === 'red',
                })} pl={2}>
                    <Card style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <CardActionArea aria-label={'Indice for ' + props.indexID} onClick={() => { setOpen(!open) }}>
                            <Box p={2} className={classes.dataBox}>
                                <Grid container spacing={2} alignItems="center" justify="center">
                                    <Grid container item xs={12} justify="space-between">
                                        <Typography>
                                            <CopyText className={classes.copyText} text={`${props.indexID}`}/>
                                        </Typography>
                                    </Grid>
                                    <Grid container item xs={12} className={classes.textCenter}>
                                        <Grid item xs={4}>
                                            <Box>Created</Box>
                                            <Box className={classes.nodeData}>
                                                {Moment(props.indexData.creation_date).format(theme.date.long)}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Box>Size</Box>
                                            <Box className={classes.nodeData}>{Helpers.formatBytes(props.indexData.size)}</Box>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Box>Docs</Box>
                                            <Box className={classes.nodeData}>{props.indexData.number_of_docs}</Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} className={clsx({
                                        [classes.textCenter]: true,
                                        [classes.hidden]: !open,
                                    })}>
                                        <Grid item xs={4}>
                                            <Box>Pri Shards</Box>
                                            <Box className={classes.nodeData}>{props.indexData.number_of_primary_shards}</Box>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Box>Rep Shards</Box>
                                            <Box className={classes.nodeData}>{props.indexData.number_of_replica_shards}</Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </CardActionArea>
                        <CardContent className={classes.contentPad}>
                            {clusterPerms.delete && !props.indexData.rw &&
                                <IconButton
                                    aria-label="delete"
                                    onClick={() => { props.onDelete(props.indexData.ip) }}
                                    size="large">
                                    <DeleteIcon />
                                </IconButton>
                            }
                        </CardContent>
                    </Card>
                </Box>
            </Paper>
        </Grid>
    );
};

Indices.propTypes = {
    indexData: PropTypes.object,
    indexID: PropTypes.string,
    onDelete: PropTypes.func,
};

export default Indices;
